import { useEffect, useRef, useState } from 'react';

const BASE_SRC = 'https://www.youtube.com/embed/Kkg5luc1mIU?rel=0&modestbranding=1&playsinline=1&enablejsapi=1';
const AUTOPLAY_SRC = `${BASE_SRC}&autoplay=1&mute=1`;

const VideoEmbed = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [src, setSrc] = useState(BASE_SRC);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSrc(AUTOPLAY_SRC);
        } else {
          // Reset src to stop playback when out of view
          setSrc(BASE_SRC);
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="relative py-20 px-6 flex flex-col items-center overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #060606 0%, #080808 100%)' }}
    >
      {/* Top border glow */}
      <div
        className="absolute top-0 left-0 right-0 h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(212,168,66,0.5) 50%, transparent 100%)' }}
      />

      {/* Radial ambient glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at center, rgba(212,168,66,0.06) 0%, transparent 65%)' }}
      />

      {/* Badge */}
      <div
        className="relative z-10 inline-flex items-center gap-2 mb-8 px-5 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase"
        style={{
          background: 'rgba(212,168,66,0.1)',
          border: '1px solid rgba(212,168,66,0.35)',
          color: '#D4A842',
          fontFamily: "'Glacial Indifference', sans-serif",
        }}
      >
        <span>✦</span> Watch
      </div>

      {/* Video container — landscape (16:9) */}
      <div
        ref={containerRef}
        className="relative z-10 w-full max-w-3xl rounded-2xl overflow-hidden"
        style={{
          aspectRatio: '16 / 9',
          border: '1px solid rgba(212,168,66,0.3)',
          boxShadow: '0 0 60px rgba(212,168,66,0.12)',
        }}
      >
        <iframe
          key={src}
          src={src}
          title="Revive Nation – Reclaim Conference"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 w-full h-full"
          style={{ border: 'none' }}
        />
      </div>
    </section>
  );
};

export default VideoEmbed;
